import React, { useCallback, useContext, useEffect, useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'
import { addcontext } from '../../ContextShare/ContextShare';
import AddMember from './AddMember';
import AddNewMember from './AddNewMember';
import { DeleteMember, EditMember, EditMemberLessDetails, FiterDashBoardAdmin, FiterMemberListAdmin, GetKlaListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla, MembersListApi, SearchAMember, getMemberListInTable, getMemberListLessDeatils, getMemberListLessDeatilsByCondition, getMemberListLessDeatilsByConditionNewSORTED, getMemberListLessDeatilsByConditionNewSORTEDWithKlaSessioNFIlter } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Select from "react-select";
import DeleteModal from '../DeleteModal';
import PopoverIcon from '../../Components/InfoIcon'
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import { toast, ToastContainer } from 'react-toastify';
import { debounce } from 'lodash'; // Using lodash debounce for rate limiting

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90%',
    overflowY: 'auto' // Make the Box scrollable


};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function MemberListLessDetails() {
    const { addMember, setaddMember } = useContext(addcontext)
    const { filterMembersTable, setfilterMembersTable } = useContext(addcontext)
    const [isFilteredData, setisFiltereddata] = useState()
    const [membersList, setMembersList] = useState([])
    const baseUrl = process.env.REACT_APP_BASEURL
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setImagePreview('')
    }
    const [klaListF, setKlaListF] = useState([]);
    const [sessionListF, setSessionListF] = useState([]);
    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [errorFilterMessage, seterrorFilterMessage] = useState()
    const [searchQuery, setSearchQuery] = useState()
    const [klaList, setKlaList] = useState([])
    const [klaoptions, setKlaOptions] = useState([]);
    const [token, setToken] = useState()
    const [isMM, setIsMM] = useState(false)
    const [cleared, setCleared] = useState(1)
    const [idToDelete, setidToDelete] = useState()
    const [open4, setOpen4] = useState(false);
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
    }

    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,


        },
        {
            name: 'Member Id',
            selector: row => row.id,
            sortable: true,


        },
        {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
        {
            name: 'Photo',
            selector: row => row.photo,
            // sortable: true,


        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,


        },

        {
            name: 'Elected Date',
            selector: row => row.electeddate,
            sortable: true,
        },
        {
            name: 'End Date',
            selector: row => row.endtdate,
            sortable: true,
        },

        {
            name: 'Uploader',
            selector: row => row.uploader,
            sortable: true,
        },
        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },
        {
            name: 'Active',
            selector: row => row.active,
            sortable: true,
        },

    ];
    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            MembersList()
        }
        else {
            console.log('token fetching failed');
        }
    }, [token, isEdited, addMember, filterMembersTable, cleared])
    const MembersList = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };

        const newobjForApi = { kla_id: isFilteredData?.kla_id, session_id: isFilteredData?.session_id, member: filterMembersTable }
        const result = !isFilteredData ? await getMemberListLessDeatilsByConditionNewSORTED(filterMembersTable, reqHeader) : await getMemberListLessDeatilsByConditionNewSORTEDWithKlaSessioNFIlter(newobjForApi, reqHeader)
        setMembersList(result?.data?.data)
        console.log(result);
        seterrorFilterMessage(result?.response?.data?.message)

    }
    var data = []
    membersList && membersList?.map((item, index) => {
        const slno = index + 1
        const id = item.member_id
        const photo = <img src={`${baseUrl}${item.member_image}`} className='h-20 w-20 p-2 rounded' />
        const name = item.member_name;
        const electeddate = item.member_start_date;
        const endtdate = item.member_end_date;
        const uploader = item.uploaded_by
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)
        const Action = <a style={{ color: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEdit(item)}>Edit</a>;
        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.member_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const newObj = { slno, id, photo, name, electeddate, endtdate, active, uploader, createdAt, updatedAt, Action };
        data.push(newObj);
    })
    const [imagePreview, setImagePreview] = useState('');

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const newFormData = { ...dataToEdit }; // Create a copy of the dataToEdit object
            newFormData.member_image = file; // Update the member_image property with the new file
            setDataToEdit(newFormData); // Update the state with the new object
            console.log(newFormData);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };


    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()

    }

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            "Authorization": `${token}`
        };

        const formData = new FormData(); // Create a FormData object

        // Append the dataToEdit fields to the FormData object
        Object.keys(dataToEdit).forEach(key => {
            if (key === 'member_end_date') {
                if (dataToEdit[key] !== null) {
                    formData.append(key, dataToEdit[key]);
                }
            } else {
                formData.append(key, dataToEdit[key]);
            }
        });


        // Append the member_image file to the FormData object
        // formData.append("member_image", dataToEdit.member_image);

        // Make the API call with FormData and headers
        try {
            console.log(formData);
            const result = await EditMemberLessDetails(formData, reqHeader, dataToEdit.member_id)
            // const data = await result.json();
            console.log(result);
            if(result.status==200){
                handleClose();
                setIsEdited(isEdited + 1);
                toast.success("Member list edites successfully")
            }else{
                toast.error(result?.response?.data?.message??"There was a problem editing!!!")
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteMember(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApiFilter = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionListF(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApiFilter();
    }, [selectedOptionKla]);

    const sessionoptionsF = sessionListF.map((item) => ({
        value: item.session_id,
        label: `Session${item.session_no}`,
    }));

    const handlechange = (option) => setSelectedOptionKla(option);
    const handlechangesession = (option) => setSelectedOptionsession(option);

    const FilterAdminVideoTable = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        // const member_id = selectedOptionMember?.value;
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        // if (member_id) obj.member_id = member_id;
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FiterMemberListAdmin(obj, reqHeader);
            setisFiltereddata(obj)
            // setVideoData(result?.data || []);
            setMembersList(result?.data?.data || [])
            seterrorFilterMessage(result?.response?.data?.message)
            // setProgressResult(result)

            console.log(result);
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession) {
            FilterAdminVideoTable()

        }
    }, [selectedOptionKla, selectedOptionsession]);

    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setisFiltereddata()
        MembersList()
        setSearchQuery('')
    }

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------

    const handleClearFilterAll = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        setisFiltereddata()
        setCleared(cleared + 1)
    }
    const handleSearch = async (e) => {
        setSearchQuery(e);
        
        if (e.trim()) { // Check for non-empty input
          const tokenn = sessionStorage.getItem('access_token');
          const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${tokenn}`
          };
          
          try {
            const res = await SearchAMember({ search_query: e }, reqHeader);
            if (res.status === 200) {
              setMembersList(res?.data?.data);
              seterrorFilterMessage(res?.response?.data?.message);
            } else {
              seterrorFilterMessage(res?.response?.data?.message);
              setMembersList([])
            }
          } catch (error) {
            console.error('Error fetching members:', error);
            seterrorFilterMessage('An error occurred while fetching members.');
          }
        } else {
        //   toast.warning('Please enter a member name to search');
        setIsEdited(isEdited+1)
        }
      };
      
      // Debounce search to avoid excessive API calls
      const debouncedSearch = useCallback(debounce((e) => handleSearch(e), 300), []);
      
      const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
        debouncedSearch(e.target.value);
      };
    return (
        <>
            {addMember ? (
                <AddNewMember />
            ) : (
                <>
                <>
                                <div className='flex flex-row justify-center gap-5 pb-1'>
                                <div className='flex flex-col w-3/12  text-blue-400'>
                                <div className='flex flex-row justify-between rounded-lg items-center '>
                                    <input
                                        placeholder='Search by Member name...'
                                        className='w-full h-9 p-2 outline-none focus:outline-none border-t border-b border-s rounded-s-lg border-gray-400 placeholder:text-gray-600'
                                        value={searchQuery}
                                        onChange={handleInputChange}

                                    />
                                    <div   onClick={() => handleSearch(searchQuery)}  className='hover:text-white font-bold text-lg border hover:bg-blue-500 text-blue-500 border-blue-500 h-full flex items-center justify-center rounded-r-lg w-10 cursor-pointer'> <Icon icon="ion:search" /></div>
                                </div>

                            </div>
                                    <div className='flex flex-row w-3/12  text-blue-400 '>
                                        <Select
                                            placeholder='KLA'
                                            className='w-full'
                                            options={klaoptionsF}
                                            value={selectedOptionKla}
                                            onChange={handlechange}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderRadius: '0.5rem',
                                                }),
                                            }} />
                                    </div>

                                    <div className='flex flex-row w-3/12 text-blue-400 '>
                                        <Select
                                            placeholder='Session'
                                            className='w-full'
                                            options={sessionoptionsF}
                                            value={selectedOptionsession}
                                            onChange={handlechangesession}
                                            styles={{
                                                control: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    borderRadius: '0.5rem',
                                                }),
                                            }} />
                                    </div>
                                    <div className='flex flex-col '>
                                        <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                            <span>Clear Filter</span>
                                            <Icon icon="bx:reset" />
                                        </button>
                                    </div>

                                </div></>
                    {/* <PopoverIcon content="Map Member to a session in Manage Session. Constituency, Role, etc in Manage Session > Add New Session  " /> */}
                    <>
                        {membersList?.length > 0 ?
                            <>
                                <DataTable
                                    title={<div className='flex flex-row items-center '><span className='me-2'>Members List</span> <PopOver dataToDisplay={'Add Edit Members details'} /><div><h5 className='text-center ms-5 text-sm text-gray-700'>{filterMembersTable?.all_member ? '( Currently Displaying All Members )' : filterMembersTable?.non_member ? '( Currently Displaying Non-Members )' : '( Currently Displaying Members )'}</h5></div></div>}
                                    columns={columns}
                                    data={data}
                                    customStyles={customStyles}
                                    pagination
                                    dense
                                    highlightOnHover
                                    selectableRowsHighlight
                                    paginationPerPage={50} // Initial page size
                                    paginationRowsPerPageOptions={[50, 100, 200, 500]} // Options for users to change page size
                                // selectableRows
                                // progressPending
                                // progressComponent={<h1>load</h1>}
                                />
                            </>
                            :

                            <>
                                {!errorFilterMessage ? <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                    <SyncLoader
                                        color="#3498db"
                                        loading={true}
                                        speedMultiplier={1}
                                    />
                                    <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

                                </div>
                                    :
                                    // <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                    //     <p className=" flex flex-row items-center"><span>No record found</span></p>
                                    //     <button onClick={handleClearFilterAll} className='px-10 py-2 bg-red-500 rounded hover:bg-red-600 text-white'>Clear filter</button>
                                    // </div>
                                    <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                    <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorFilterMessage}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
                                    </div>
                                }
                            </>
                        }
                    </>
                </>
            )}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>

                        <div className='w-full items-center flex-col flex'>
                            <label htmlFor="memberimage" className='w-10/12 h-40 cursor-pointer'>
                                <div className='bg-success border-dashed border-2 h-full overflow-hidden p-1 rounded border-light-blue-600 flex justify-center items-center flex-col'>
                                    {imagePreview ? (
                                        <img className='h-36 w-36' src={imagePreview} alt="Uploaded Preview" />
                                    ) : (
                                        <>
                                            <img className='h-32 w-32' src={`${baseUrl}${dataToEdit?.member_image}`} alt="Upload image" />
                                            <span className='text-blue-500 underline text-sm'>Upload new image</span>
                                        </>
                                    )}
                                </div>
                            </label>
                            <input id='memberimage' type="file" style={{ visibility: 'hidden' }} onChange={handleImageUpload} />
                        </div>

                        <div className='flex flex-row gap-5items-center '>
                            <label htmlFor="nonMember">Non Member</label>
                            <input type="checkbox" id='nonMember' className='w-10'
                                checked={dataToEdit?.is_non_member}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, is_non_member: e.target.checked })} />
                        </div>

                        <div className='w-10/12 flex flex-col'>
                            <label htmlFor="eventname">Name</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.member_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, member_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Name Malayalam</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.mal_member_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, mal_member_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Sorting Name</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.sorting_name}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, sorting_name: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Start date</label>
                            <input
                                id='field3'
                                value={dataToEdit?.member_start_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, member_start_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field4">End date</label>
                            <input
                                id='field4'
                                value={dataToEdit?.member_end_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, member_end_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />

                        </div>
                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mt-5'>
                            <button className='px-6 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-6 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>

            <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
        theme="light"
      />

        </>
    )
}

export default MemberListLessDetails